export class DialogKindConstant {

  //#region Properties

  public static readonly confirmation = 'confirmation';

  public static readonly error = 'error';

  public static readonly info = 'info';

  public static readonly warning = 'warning';

  //#endregion

}
